import { render, staticRenderFns } from "./TRow.vue?vue&type=template&id=027aef8b&scoped=true&"
import script from "./TRow.vue?vue&type=script&lang=js&"
export * from "./TRow.vue?vue&type=script&lang=js&"
import style0 from "./TRow.vue?vue&type=style&index=0&id=027aef8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027aef8b",
  null
  
)

export default component.exports